import { VISIT_PASS_HEADER, visitPassDTOSchema, visitPassSignatureUploadDTOSchema, } from '@instanexus/contracts';
import { PUBLIC_API_PREFIX, dataEnvelopeSchema } from '../transport.js';
const passSchema = dataEnvelopeSchema(visitPassDTOSchema);
const uploadSchema = dataEnvelopeSchema(visitPassSignatureUploadDTOSchema);
function passHeaders(token) {
    return { [VISIT_PASS_HEADER]: token };
}
export function createVisitPassResource(transport) {
    return {
        async get(token) {
            const envelope = await transport.request({
                path: `${PUBLIC_API_PREFIX}/visit-pass`,
                schema: passSchema,
                auth: 'none',
                headers: passHeaders(token),
            });
            return envelope.data;
        },
        async saveAnswers(token, input) {
            const envelope = await transport.request({
                method: 'PUT',
                path: `${PUBLIC_API_PREFIX}/visit-pass/answers`,
                schema: passSchema,
                body: input,
                auth: 'none',
                headers: passHeaders(token),
            });
            return envelope.data;
        },
        async uploadSignature(token, image) {
            const envelope = await transport.requestUpload({
                path: `${PUBLIC_API_PREFIX}/visit-pass/signatures`,
                schema: uploadSchema,
                contentType: 'image/png',
                body: image,
                auth: 'none',
                headers: passHeaders(token),
            });
            return envelope.data;
        },
        async signAgreement(token, documentId, input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${PUBLIC_API_PREFIX}/visit-pass/agreements/${encodeURIComponent(documentId)}/sign`,
                schema: passSchema,
                body: input,
                auth: 'none',
                headers: passHeaders(token),
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=visit-pass.js.map